<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-5 position: absolute;">
                <v-btn v-if="inEditMode && vacancy.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn
                    v-if="!inEditMode && $myStore.state.user.user_role_id != 3"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="editClick()"
                >
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 84vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="3" xl="3" lg="3" md="3">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.vacancyInformation') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="5" v-if="vacancy.id != 0">
                                <InputField :readonly="true" v-model="vacancy.id" :label="$t('fields.id')"></InputField>
                            </v-col>
                            <v-col v-if="vacancy.id != 0" cols="7"></v-col>
                            <v-col v-if="vacancy.id == 0" cols="12"></v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="vacancy.job_title"
                                    :errorBorder="!vacancyValidation.job_title"
                                    :label="$t('fields.jobTitle')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <DropdownMultiple
                                    :readonly="!inEditMode"
                                    v-model="vacancy.ranks"
                                    :ajax="true"
                                    :data="'ranks-abbreviation'"
                                    :errorBorder="!vacancyValidation.ranks"
                                    :label="'* ' + $t('fields.rank')"
                                ></DropdownMultiple>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="vacancy.salary"
                                    :errorBorder="!vacancyValidation.salary"
                                    :label="$t('fields.salary')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="250"
                                    v-model="vacancy.salary_details"
                                    :errorBorder="!vacancyValidation.salary_details"
                                    :label="$t('fields.salaryDetails')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="7">
                                <DatePicker
                                    :readonly="!inEditMode"
                                    v-model="vacancy.joining_date"
                                    :errorBorder="!vacancyValidation.joining_date"
                                    :date-label="$t('fields.joiningData')"
                                ></DatePicker>
                            </v-col>
                            <v-col cols="5" class="text-right pa-0 pl-4">
                                <CheckBox
                                    class="text-right pa-0"
                                    :readonly="!inEditMode"
                                    v-model="vacancy.asap"
                                    :label="$t('fields.asap')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    :maxlength="50"
                                    v-model="vacancy.rotation"
                                    :errorBorder="!vacancyValidation.rotation"
                                    :label="$t('fields.rotation')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <DropdownMultiple
                                    :readonly="!inEditMode"
                                    v-model="vacancy.vessel_types"
                                    :ajax="true"
                                    data="vessel-types"
                                    :label="$t('fields.typeOfvessel')"
                                ></DropdownMultiple>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="500"
                                    v-model="vacancy.additional_information"
                                    :errorBorder="!vacancyValidation.additional_information"
                                    :label="$t('fields.additionalInformation')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="250"
                                    v-model="vacancy.job_requirements"
                                    :errorBorder="!vacancyValidation.job_requirements"
                                    :label="$t('fields.jobRequirements')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="250"
                                    v-model="vacancy.vessel_information"
                                    :errorBorder="!vacancyValidation.vessel_information"
                                    :label="$t('fields.vesselInformation')"
                                ></TextArea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="3" xl="3" lg="3" md="3">
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.vacancyMetrics') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12" class="text-right">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="vacancy.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="vacancy.status_id"
                                    :ajax="true"
                                    :data="'vacancy-statuses'"
                                    :errorBorder="!vacancyValidation.status_id"
                                    :label="'* ' + $t('fields.status')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <NumberField
                                    :max="100"
                                    :readonly="!inEditMode"
                                    v-model="vacancy.number_of_offered_positions"
                                    :errorBorder="!vacancyValidation.number_of_offered_positions"
                                    :label="$t('fields.positionsOffererdNo')"
                                ></NumberField>
                            </v-col>
                            <v-col cols="12">
                                <NumberField
                                    :readonly="true"
                                    v-model="totalApplications"
                                    :label="$t('fields.applied')"
                                ></NumberField>
                            </v-col>
                            <v-col cols="12">
                                <NumberField
                                    :readonly="true"
                                    v-model="totalPlacements"
                                    :label="$t('fields.hired')"
                                ></NumberField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.employer') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="vacancy.entity_id"
                                    :ajax="true"
                                    :data="'entities'"
                                    :errorBorder="!vacancyValidation.entity_id"
                                    :label="$t('fields.entity')"
                                    @input="loadVessels"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <DropdownMultiple
                                    :readonly="!inEditMode"
                                    v-model="selectedMaritimeObjects"
                                    :ajax="false"
                                    :data="entityVessels"
                                    :label="$t('fields.vessels')"
                                    :key="componentKey"
                                ></DropdownMultiple>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6">
                <VacancyApplicationsTable :vacancy="vacancy" />
                <VacancyPlacementsTable :vacancy="vacancy" />
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import DatePicker from '@/components/trinkets/DatePicker';
import Vacancy from '../models/Vacancy';
import InputField from './trinkets/InputField';
import NumberField from '@/components/trinkets/NumberField';
import TextArea from '@/components/trinkets/TextArea';
import VacancyApplicationsTable from '@/components/VacancyApplicationsTable.vue';
import VacancyPlacementsTable from '@/components/VacancyPlacementsTable.vue';
import DropdownMultiple from './trinkets/DropdownMultiple';

export default {
    name: 'vacancy',
    components: {
        CheckBox,
        DatePicker,
        Dropdown,
        InputField,
        NumberField,
        TextArea,
        VacancyApplicationsTable,
        VacancyPlacementsTable,
        DropdownMultiple,
    },
    data: function () {
        return {
            componentKey: 0,
            vacancy: new Vacancy({id: this.$route.params.id}),
            vacancyValidation: new Vacancy({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'vacancy',
            lockTimer: null,
            template_id: null,
            dateReadOnly: true,
            editReadONly: false,
            totalApplications: 0,
            totalPlacements: 0,
            selectedMaritimeObjects: [],
            entityVessels: [],
        };
    },
    methods: {
        loadVessels() {
            if (this.vacancy.entity_id) {
                this.$APICall('get', 'maritime-objects-for-entity/' + this.vacancy.entity_id, {}, (data, success) => {
                    if (success) {
                        this.entityVessels = data.maritime_objects;
                        this.componentKey++;
                    }
                });
            }
        },
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.vacancy.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.vacancy.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            let missingFields = '';

            if (this.vacancy.ranks.length < 1) {
                success = false;
                this.vacancyValidation.ranks = false;
                missingFields += this.$t('fields.rank') + '<br/>';
            } else {
                this.vacancyValidation.ranks = true;
            }

            if (this.vacancy.asap == false) {
                if (this.vacancy.joining_date == null || this.vacancy.joining_date == '') {
                    success = false;
                    this.vacancyValidation.joining_date = false;
                    missingFields += this.$t('fields.joiningData') + '<br/>';
                } else {
                    this.vacancyValidation.joining_date = true;
                }
            }
            if (this.vacancy.status_id == null || this.vacancy.status_id == '') {
                success = false;
                this.vacancyValidation.status_id = false;
                missingFields += this.$t('fields.status') + '<br/>';
            } else {
                this.vacancyValidation.status_id = true;
            }
            if (this.vacancy.number_of_offered_positions < 1 || this.vacancy.number_of_offered_positions > 100) {
                success = false;
                this.vacancyValidation.number_of_offered_positions = false;
                missingFields += this.$t('fields.positionsOffererdNo') + '<br/>';
            } else {
                this.vacancyValidation.number_of_offered_positions = true;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.vacancy.id != 0) {
                    action = 'put';
                    addition = '/' + vm.vacancy.id;
                }
                vm.vacancy.vessels = vm.selectedMaritimeObjects;
                this.$APICall(action, 'vacancies' + addition, vm.vacancy, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.vacancy.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                            if (this.lockTimer !== null) clearInterval(this.lockTimer);
                            vm.$removeLock(vm, vm.lockKey + '|' + vm.vacancy.id);
                            vm.vacancy.id = data.id;
                            vm.$myStore.commit('setBreadcrumbs', [
                                {text: vm.$t('modules.vacancies'), href: '/#/vacancies', disabled: false},
                                {
                                    text: vm.vacancy.job_title + ' (' + vm.vacancy.id + ')',
                                    href: '/#/vacancies/' + vm.vacancy.id,
                                    disabled: true,
                                },
                            ]);
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                            if (this.lockTimer !== null) clearInterval(this.lockTimer);
                            vm.$removeLock(vm, vm.lockKey + '|' + vm.vacancy.id);
                        }
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    } else {
                        vm.$notify(vm.$t('alerts.basicError'));
                    }
                });
            } else {
                let alert = 'Missing fields: <br/> ' + missingFields;
                this.$alert(alert);
            }
        },
    },

    watch: {
        'vacancy.asap': {
            handler: function () {
                if (this.vacancy.asap != false) {
                    this.vacancy.joining_date = null;
                    this.dateReadOnly = true;
                } else {
                    this.dateReadOnly = false;
                }
            },
        },
    },
    beforeDestroy() {
        if (this.lockTimer !== null) clearInterval(this.lockTimer);
    },
    beforeRouteLeave(to, from, next) {
        let vm = this;
        if (this.inEditMode) {
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    vm.$removeLock(this, this.lockKey + '|' + this.vacancy.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.vacancy.id != 0) {
            this.$APICall('get', 'vacancies/' + this.vacancy.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.vacancy = usableData['object'];
                    vm.loadVessels();
                    vm.selectedMaritimeObjects = usableData['selectedVessels'];
                    vm.totalApplications = usableData['totalApplications'];
                    vm.totalPlacements = usableData['totalPlacements'];
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.vacancies'),
                            href: '/#/vacancies',
                            disabled: false,
                        },
                        {
                            text: vm.vacancy.job_title + ' (' + vm.vacancy.id + ')',
                            href: '/#/vacancies/' + vm.vacancy.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                        vm.componentKey += 1;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.vacancies'),
                    href: '/#/vacancies',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newVacancy'),
                    href: '/#/vacancies/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
            this.dateReadOnly = false;
            this.editReadONly = true;
        }
    },
};
</script>

<style scoped></style>
